import { RunnerType } from 'adapters/repositories/typeDefinition';

export const shouldPay = (runner: RunnerType) => {
  // 特定のstudent_groupの人は無条件にOK
  if (runner.student_group === 'soccer-club') {
    return true;
  }
  return false;
};
